export enum MainNavMode {
  Side = 'side',
  Over = 'over',
  Push = 'push'
}
